export default "__VITE_ASSET__4c2300e5__"